<div class="modal-header">
    <h4 class="modal-title">{{'planSummary_editMedicalPersonId_title' | translate}}</h4>
</div>

<div class="modal-body">
    <form #form="ngForm">
        <div class="form-field">
            <label class="form-label">{{'planSummary_lblMedicalPersonId' | translate}}</label>
            <input class="form-control" name="medicalPersonId" [(ngModel)]="medicalPersonId" maxlength="20" />
        </div>
    </form>
</div>

<div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="cancel()" [disabled]="isSaving">{{'cancel' | translate}}</button>

    <button class="btn btn-primary" (click)="submit()" type="button" [disabled]="isSaving || !form.valid">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isSaving"></span>
        {{'save' | translate}}
    </button>
</div>
